import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.

export const useGraphsTooltipStyles = makeStyles()((theme: Theme) => ({
  customTooltip: {
    display: 'block',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    width: theme.spacing(40),
    zIndex: 10,
    textAlign: 'center',
    boxShadow: theme.shadows[1],
    '& ul': {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      padding: theme.spacing(2),
    },
    '& ul li': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  label: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.disabled,
  },
  value: {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
  },
  usage: {
    textAlign: 'right',
    paddingRight: theme.spacing(2),
  },
}))
